<template>
  <form
    method="post" enctype="multipart/form-data">
    <div class="container" id="dropzone" style="height: 100vh;" >
      <nav class="navbar navbar-light bg-light">
        <a class="navbar-brand" href="#">
          <img
              src="/images/archivium.svg"
              width="30"
              height="30"
              class="d-inline-block align-top"
              alt=""
          />
          Archi<strong>Mail</strong>
        </a>
      </nav>
      <div class="row mt-4">
        <div class="col-lg-9">
          <div class="form-group">
            <label for=""></label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white" id="basic-addon1"
                >Da</span
                >
              </div>

              <select
                  class="form-control"
                  name=""
                  id=""
                  v-model="form.from"
                  placeholder="Seleziona account" disabled
              >
                <option disabled value="" selected>Seleziona account</option>
                <option
                    v-for="account in accounts"
                    :key="account.address"
                    :value="account.address"
                >
                  {{ account.alias }} ({{ account.address }})
                </option>
              </select>
            </div>
          </div>

          <datalist id="contacts">
            <option
                v-for="contact in contacts"
                :key="contact.id"
                :value="contact.address"
            ></option>
          </datalist>

          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white" id="basic-addon1">A</span>
              </div>
              <ContactInput ref="to" :contacts="contacts" :groups="groups" :recipients_emails="form.to" :account_id="route.query.account" @updateRecipients="handleRecipientsUpdate" class="form-control"/>
            </div>
          </div>

          <div class="form-group" :class="{'d-none': !showCC}">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white" id="basic-addon1">Cc</span>
              </div>
              <ContactInput ref="cc" :contacts="contacts" :groups="groups" :recipients_emails="form.cc" :account_id="route.query.account" @updateRecipients="handleCCUpdate" class="form-control"/>
            </div>
          </div>

          <!--<div class="form-group" :class="{'d-none': !showBCC}">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white" id="basic-addon1">Ccn</span>
              </div>
              <ContactInput ref="bcc" :contacts="contacts" :groups="groups" :recipients_emails="form.bcc" :account_id="route.query.account" @updateRecipients="handleBCCUpdate" class="form-control"/>
            </div>
          </div>-->

          <a class="btn btn-link" @click.prevent="showCC = true" href="#" v-if="!showCC">
            +Cc
          </a>
          <!--<a class="btn btn-link" @click.prevent="showBCC = true" href="#" v-if="!showBCC">
            +Ccn
          </a>-->

          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white" id="basic-addon1">Oggetto</span>
              </div>
              <input v-model="form.subject" class="form-control" placeholder=""/>
            </div>
          </div>
          <div class="form-group">
            <quill-editor ref="quill" theme="snow" :value="myHTML" @text-change="updateHTML"/>
          </div>

          <div class="form-group">
            <div id="uploaded-files-container" class="d-flex flex-wrap align-items-center gap-2 mt-2" >

            </div>
          </div>

          <button
              v-if="userCan(CUP.SEND_MESSAGES)"
              class="btn btn-primary"
              @click.prevent="send()"
              :disabled="!enableSend">
            <span v-if="!isSending"><i class="fas fa-paper-plane"></i> &nbsp;Invia</span>
            <div class="spinner-border spinner-border-sm text-light" v-else>
              <span class="sr-only">Invio...</span>
            </div>
          </button>

          <button type="button" class="btn btn-primary mx-2" id="custom-upload-button" :disabled="isSending">
              <span><i class="fas fa-paperclip" style="margin: 0;"></i>
              &nbsp;Allega</span>
              <!-- <span>Clicca qui o trascina i file per caricare allegati</span> -->
            </button>

          <label class="ml-2" @click="updateDraft()">Bozza{{ !draftSaved ? ' non ' : ' ' }}salvata</label>
        </div>
        <div v-if="isLoading" class="form-group mt-4">
          Caricamento in corso...
        </div>
        <div class="col-lg-3">
          <div class="form-group">
              <input type="hidden" name="_id" :value="messageUuid"/>
          </div>
        </div>
      </div>
    </div>
  </form>

</template>

<script setup>
import {useRoute} from "vue-router";
import {
  ref,
  computed,
  inject,
  useTemplateRef,
  nextTick,
  watch,
  onMounted
} from 'vue';
import axios from '@/services/axios.setup.js';
import {QuillEditor} from "@vueup/vue-quill";
import ContactInput from "@/components/Messages/ContactInput.vue";
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import * as messageService from "@/services/message.service.js";
import { FOLDERS } from "@/services/message.service.js";
import * as addressbookService from "@/services/addressbook.service.js";
import * as contactService from "@/services/contact.service.js";
import * as accountService from "@/services/account.service.js";
import { CORE_USER_PERMISSIONS as CUP } from "@/enums/CoreUserPermissions";
import Dropzone from "dropzone";
import { onBeforeUnmount } from "vue";
import { errorToast } from "@/services/toast.service";

const route = useRoute();
const quillRef = useTemplateRef('quill');
const toRef = useTemplateRef('to');
const ccRef = useTemplateRef('cc');
const bccRef = useTemplateRef('bcc');
const props = defineProps([''])
const messageUuid = route.query.id;
const accountUuid = route.query.account;
const type = route.query.type;
const folder = route.query.folder;
const refId = route.query['ref-id'];
const debounce = inject('debounce');
const tryAsync = inject('tryAsync');
const userCan = inject('userCan');

const debouncedUpdate = debounce(updateDraft, 2000); // 2s di debounce
const fastDebouncedUpdate = debounce(updateDraft, 100); // 100ms di debounce (per attachments)

const myHTML = ref('');
const accounts = ref([]);
const account = ref(null);
const contacts = ref([]);
const isSending = ref(false);
const uploadInProgress = ref(false);
const form = ref({
  uuid: messageUuid,
  from: accountUuid,
  to: [],
  cc: [],
  bcc: [],
  subject: '',
  body: '',
  files: []
});
const groups = ref([]);
const showCC = ref(false);
const showBCC = ref(false);
const draftSaved = ref(true);
const isLoading = ref(true);

const enableSend = computed(() => {
  return !isSending.value
    && !uploadInProgress.value
    && form.value.to.filter(e => e).length > 0
    && form.value.subject !== '';
});

watch(form, () => {
  // Only start saving the form when all data is ready
  if (isLoading.value) return;
  // Every time the form change, we need to save the draft
  draftSaved.value = false;
  // Save it after 2 seconds, to avoid doing it at every keystroke
  debouncedUpdate();
}, { deep: true });


async function send() {

  // Stops possible programmed draft updates
  debouncedUpdate.cancel();
  fastDebouncedUpdate.cancel();

  isSending.value = true;

  // Here I do not want to use the component `updateDraft`
  // function because I want to handle the error myself.
  await tryAsync(
    messageService.updateDraft(accountUuid, form.value), // try
    (errData) => {
      isSending.value = false;
      return errData.message
    }, // catch
  );

  draftSaved.value = true;

  await tryAsync(
    messageService.send(accountUuid, messageUuid), // try
    "Si è verificato un problema durante l'invio", // show catched error
    () => isSending.value = false  // finally
  );

  window.alert('Email inviata con successo')
  window.close()
}


function handleRecipientsUpdate(recipients) {
  form.value.to = recipients.map(recipient => recipient.email);
}

function handleCCUpdate(ccs) {
  form.value.cc = ccs.map(cc => cc.email);
}

function handleBCCUpdate(bccs) {
  form.value.bcc = bccs.map(bcc => bcc.email);
}

function updateHTML(event) {
  form.value.body = quillRef.value.getHTML();
}

async function updateDraft() {
  try {
    await messageService.updateDraft(accountUuid, form.value);
  } catch (e) {
    console.warn("The draft was not saved. This is the issue we found: ", e);
    return; // We do not want to say that the draft was saved
  }

  draftSaved.value = true;
}

function trimEmails(recipients) {
  return recipients.map((recipient) => {
    if (recipient.includes('<')) {
      let [_, rest] = recipient.split('<');
      let [email, __] = rest.split('>');
      return email;
    }
    return recipient;
  });
}

// Questa funzione serve per Dropzone (apparentemente)
function getProcessedHeaders() {
  // Crea una configurazione iniziale della richiesta
  const config = {
    headers: {}
  };

  // Applica manualmente gli interceptor di Axios
  axios.interceptors.request.handlers.forEach((interceptor) => {
    if (interceptor.fulfilled) {
      try {
        // Esegui l'interceptor "fulfilled" per aggiornare il config
        Object.assign(config, interceptor.fulfilled(config));
      } catch (error) {
        console.error("Errore durante l'applicazione dell'interceptor:", error);
      }
    }
  });

  return config.headers;
}

function getEmailList(emailString) {
  const emailList = emailString.split(',');
  const regex = /<([^>]+)>/;

  return emailList
    .map(email => {
      const match = email.match(regex);
      return match ? match[1] : null;
    })
    .filter(email => email !== null);
}

function escapeHTML(text) {
  let div = document.createElement('div');
  div.innerText = text;
  return div.innerHTML;
}

async function init() {
  const companyData = await accountService.companyData(accountUuid);
  accounts.value = companyData.accounts;

  account.value = accounts.value.find(x => x.uuid === accountUuid);
  form.value.from = account.value.address;

  contacts.value = await contactService.getAll(accountUuid);
  groups.value = await addressbookService.getAll(accountUuid);

  // Load previous draft data
  const draft = await messageService.get(
    accountUuid,
    messageUuid
  );

  // If this message is not a reply, forward or reply-all
  if (!refId) {
    // Load the message data
    form.value.to = getEmailList(draft.headers.to);
    toRef.value.loadRecipients(form.value.to, contacts.value);

    if (draft.headers.cc) {
      form.value.cc = getEmailList(draft.headers.cc);
      ccRef.value.loadRecipients(form.value.cc, contacts.value);
      showCC.value = form.value.cc.length > 0;
    }

    if (draft.headers.bcc) {
      form.value.bcc = getEmailList(draft.headers.bcc);
      bccRef.value.loadRecipients(form.value.bcc, contacts.value);
      showBCC.value = form.value.bcc.length > 0;
    }

    form.value.subject = draft.message.subject;
    form.value.body = draft.body;
    quillRef.value.pasteHTML(form.value.body);

  } else {
    // This sets up a new draft that is based on a different message
    // (reply, forward and similar)
    let messageCnt = await messageService.get(
      accountUuid,
      refId
    );

    let headers = messageCnt.headers;

    let dt = headers.date
    let locDt = new Date(dt).toLocaleString('it-IT')
    let msgType = messageCnt.message.type
    let isSent = folder == FOLDERS.SENT
    let recipients = getEmailList(headers[isSent ? 'to' : 'from']);
    form.value.subject = 'Re: ' + headers['subject'];

    /* HTML. Have to avoid indentation because it doesn't
     * play nice with the Quill editor.
     */
    myHTML.value += '<br/><br/>';
    myHTML.value += '________________________________';
    myHTML.value += '<p>';
    myHTML.value += '<b>Da:</b> ' + escapeHTML(headers.from) + '<br/>';
    myHTML.value += '<b>Data:</b> ' + locDt + '<br/>';
    myHTML.value += '<b>Oggetto:</b> ' + escapeHTML(headers.subject) + '<br/>';
    myHTML.value += '<b>A:</b> ' + escapeHTML(headers.to) + '<br/>';

    if (headers.cc) {
      myHTML.value += '<b>Cc:</b> ' + escapeHTML(headers.cc) + '<br/>'
    }

    myHTML.value += '--- <br/>' + messageCnt.body + '</p>';
    // Aggiunta della firma
    myHTML.value += draft.body;

    switch (type) {
      case 'forward':
        // nel forward nessuno, ma come se fosse nuovo
        form.value.subject = 'Fwd: ' + headers['subject'];
        break
      case 'reply':
        form.value.to = recipients;
        toRef.value.loadRecipients(form.value.to, contacts.value);
        break
      case 'reply-all':
        form.value.to = recipients;
        toRef.value.loadRecipients(form.value.to, contacts.value);

        form.value.cc = getEmailList(headers.cc);
        ccRef.value.loadRecipients(form.value.cc, contacts.value);
        showCC.value = form.value.cc.length > 0;

        form.value.bcc = getEmailList(headers.bcc);
        bccRef.value?.loadRecipients(form.value.bcc, contacts.value);
        showBCC.value = form.value.bcc.length > 0;

        break
    }

    quillRef.value.pasteHTML(myHTML.value);
    updateHTML();
  }

  isLoading.value = false;
  return draft;
}

function initDropzone(draft) {
  const baseAPI = `/accounts/${accountUuid}`
  const attachmentsUrl = axios.getUri({url: `${baseAPI}/messages/${messageUuid}/attachments`});
  const headers = getProcessedHeaders(); // Ottieni le intestazioni processate

  const dropzone = new Dropzone("#dropzone", {
    url: attachmentsUrl,
    headers: headers,
    addRemoveLinks: false,
    dictDefaultMessage: "Clicca qui o trascina i file per caricare allegati",
    clickable: "#custom-upload-button",
    previewTemplate: `
<div class="dz-preview dz-file-preview d-flex align-items-center gap-1">
<i class="fas fa-paperclip thumbnail-fallback" data-dz-thumbnail-fallback></i>
<div class="dz-filename"><span data-dz-name></span></div>
<div class="dz-size fw-bold">(<span data-dz-size></span>)</div>
<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
<div class="dz-error-message"><span data-dz-errormessage></span></div>
<i class="fas fa-times-circle remove-file-button" data-dz-remove></i>
</div>
`,
    previewsContainer: "#uploaded-files-container", // Contenitore per i file caricati
    maxFilesize: 30, // 30MB file limit
    dictFileTooBig: "File troppo pesante ({{filesize}}MiB). Dimensione massima: {{maxFilesize}}MiB."
  });

  // Adding already existing files to Dropzone
  for (let file of draft.attachments) {
    let att = {
      name: file.filename,
      size: file.size
    };

    dropzone.emit('addedfile', att);
    dropzone.emit('complete', att);
  }

  dropzone.on('removedfile', async file => {
    let config = {
      method: 'delete',
      url: attachmentsUrl,
      params: {
        fileName: encodeURI(file.name)
      }
    }

    await axios(config);

    await updateDraft();
  });

  dropzone.on('addedfile', file => {
    console.log("Added file");
    uploadInProgress.value = true;

    const fallbackIcon = file.previewElement.querySelector("[data-dz-thumbnail-fallback]");
    fallbackIcon.style.display = "block"; // Mostra l'icona
  });

  dropzone.on('queuecomplete', async file => {
    console.log('completed');
    uploadInProgress.value = false

    await fastDebouncedUpdate();
  });
}

function warnBeforeLeaving(e) {
  if (!draftSaved.value) {
    e.preventDefault();
    e.returnValue = "Alcune modifiche non sono state salvate. Sei davvero sicuro di voler uscire?";
  }
}

onMounted(async () => {
  // Questo potrebbe aver bisogno del DOM, o comunque
  // di avere i componenti figli caricati, dato che usa
  // le ref (toRef, ccRef e bccRef)
  const draft = await init();

  nextTick(() => {
    initDropzone(draft);
  });

  window.addEventListener("beforeunload", warnBeforeLeaving);
});

onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", warnBeforeLeaving);
});
</script>

<style>
.dz-preview{
  background-color: var(--bs-secondary-bg);
  padding: 4px 8px;
  min-height: 38px;
}

.dz-preview img{
  width: 30px !important;
  height: 30px !important;
  margin-right: 4px;
}

.thumbnail-fallback {
  margin-right: 4px;
}

.dz-filename {
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.dz-filename span{
  text-overflow: ellipsis;
}

.remove-file-button {
  cursor: pointer;
}

.dz-error-message {
  color: #f00;
  font-weight: bold;
}
</style>
